import './bootstrap';

import general from './containers/general';
import cart from './containers/cart';
import address from './containers/address';
import payment from './containers/payment';

general();

if (document.querySelector('.js-cart')) {
  cart();
}

if (document.querySelector('.js-address')) {
  address();
}

if (document.querySelector('.js-payment')) {
  payment();
}
